import React from "react";

import { ReactComponent as TicketOpen } from "assets/icons/TicketAbiertos.svg";
import { ReactComponent as TicketProgres } from "assets/icons/TickestProceso.svg";
import { ReactComponent as TicketClose } from "assets/icons/TickestCerrados.svg";
import { ReactComponent as TicketTotal } from "assets/icons/TickestTotal.svg";

import "styles/formTicket.css";

const ticketData = [
  {
    component: TicketOpen,
    title: "abiertos",
    color: "#fff",
  },
  {
    component: TicketProgres,
    title: "en proceso",
    color: "#fff",
  },
  {
    component: TicketClose,
    title: "cerrados",
    color: "#fff",
  },
  {
    component: TicketTotal,
    title: "totales",
    color: "#fff",
  },
];

const StatsTickets = ({ userTickets = [], typeUser }) => {
  const ItemTickets = ticketData.map((ticket) => {
    switch (ticket.title) {
      case "abiertos":
        return {
          ...ticket,
          count: userTickets.filter((obj) => obj.estado === "abierto").length,
        };

      case "en proceso":
        return {
          ...ticket,
          count: userTickets.filter((obj) => obj.estado === "en ejecucion")
            .length,
        };

      case "cerrados":
        return {
          ...ticket,
          count: userTickets.filter((obj) => obj.estado === "cerrado").length,
        };

      case "totales":
        return {
          ...ticket,
          count: userTickets.length,
        };

      default:
        return {
          ...ticket,
          count: 0,
        };
    }
  });

  return (
    <section className="container-tickets">
      {ItemTickets.map((ticket, index) => (
        <article
          key={index}
          className="ticket-standar"
          style={{
            background: typeUser && ticket.color,
          }}
        >
          <p
            className="ticket-title"
            style={{
              color: typeUser ? "#fff" : ticket.color,
            }}
          >
            {ticket.title}
          </p>

          <div className="ticket-info">
            <div
              className="ticket-icon"
              style={{
                borderColor: typeUser ? "#fff" : ticket.color,
              }}
            >
              <ticket.component
                className="iconTicket"
                style={{
                  fill: typeUser ? "#fff" : ticket.color,
                }}
              />
            </div>

            <span
              className="ticket-count"
              style={{
                color: typeUser ? "#fff" : ticket.color,
              }}
            >
              {ticket.count}
            </span>
          </div>
        </article>
      ))}
    </section>
  );
};

export default StatsTickets;
